import React, { useMemo } from 'react';

import { Button } from '@eika/button';
import { WarningCard } from '@eika/card';

import type { Account } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';

import './InvalidFromAccountInfo.scss';

export enum TransactionType {
    PAYMENT,
    TRANSFER,
    DOWNPAYMENT,
}

interface Props {
    onSelect: () => void;
    account: Account;
    transactionType: TransactionType;
}

const InvalidFromAccountInfo: React.FC<Props> = ({ onSelect, account, transactionType }) => {
    const translated = useTranslation();
    const reason = useMemo((): undefined | string => {
        if (account.type === 'LOAN') {
            return translated.loanAccount;
        }
        if (account.type === 'BSU') {
            return translated.bsuAccount;
        }

        return undefined;
    }, [account, translated]);

    const baseTitle =
        transactionType === TransactionType.TRANSFER
            ? translated.invalidFromAccount.transferNotPossible
            : translated.invalidFromAccount.paymentNotPossible;
    const title = `${baseTitle}${reason ? ` ${translated.invalidFromAccount.transferBecauseItIs} ${reason}` : ''}`;

    return (
        <WarningCard className="invalid-from-account-card" isModal title={title}>
            <p>
                {transactionType === TransactionType.TRANSFER
                    ? translated.invalidFromAccount.chooseAnotherAccountTransfer
                    : translated.invalidFromAccount.chooseAnotherAccountPayment}
            </p>
            <Button size="small" onClick={onSelect}>
                {translated.chooseAnotherAccount}
            </Button>
        </WarningCard>
    );
};

export default InvalidFromAccountInfo;
